import {
  NBS_API_REMOVE_UNSEEN_FLAG_REQUEST,
  NBS_API_REMOVE_UNSEEN_FLAG_SUCCESS,
  NBS_API_REMOVE_UNSEEN_FLAG_FAILURE
} from '../../constants/actions';

const initialState = {
  isFetching: null,
  error: null,
  response: {}
};

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case NBS_API_REMOVE_UNSEEN_FLAG_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: false,
        response: {}
      };
    case NBS_API_REMOVE_UNSEEN_FLAG_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: false,
        response: action.response
      };
    case NBS_API_REMOVE_UNSEEN_FLAG_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
        response: {}
      };
    default:
      return state;
  }
}
